import React, {Component} from 'react';
import {round} from 'helpers/number-helper';
import Const from 'constants';

class PlayerPointsView extends Component {
    render() {
        const {player} = this.props;
        const lineupPoints = round(player.lineupPoints, Const.POINTS_DECIMAL_PRECISION);

        return player.boostedPoints !== 0 ? <strong>{lineupPoints}</strong> : lineupPoints;
    }
}

export default PlayerPointsView;
